import { FunctionComponent, useState } from 'react'
import classNames from 'classnames'
import styles from './MobileAuthWidget.module.css'
import { ELEMENT_IDS } from '@/config/html-attributes.config'
import TXT from '@/messages'

type Props = {
  incomingUser: Nullable<Transformed.LoggedInUser>
  isProd: boolean
}

const MobileAuthWidget: FunctionComponent<Props> = ({
  incomingUser,
  isProd,
}: Props) => {
  const [clicked, setClicked] = useState(false)
  const email = incomingUser?.profile.email

  if (isProd) {
    return null
  }

  return (
    <div
      className={classNames(styles.AuthWidget, { [styles.Ok]: !!email })}
      onClick={() => setClicked(!clicked)}
      data-testid={ELEMENT_IDS.AUTH_WIDGET}
      id={ELEMENT_IDS.AUTH_WIDGET}
    >
      {email
        ? (
          <>
            {clicked
              ? (
                <>
                  {TXT.siteChrome.loggedInAs(email)}
                </>

              )
              : (
                // shows 'Y' if user is logged in
                <>Y</>
              )}
          </>
        )
        : (
          // shows 'N' if user is not logged in
          <>
            <>N</>
          </>
        )}
    </div>
  )
}

export default MobileAuthWidget
